<div class="feature-grid-6" role="list">
  <ng-container *ngFor="let slot of slots; trackBy: trackBySortOrder">
    <ng-container *ngIf="cellItem(slot.sortOrder) as item">
      <a
        *ngIf="cellLink(item) as link; else interactiveCell"
        class="feature-grid-6__cell"
        [class]="'feature-grid-6__cell feature-grid-6__cell--' + slot.area"
        [routerLink]="link"
        role="listitem"
      >
        <ng-container *ngTemplateOutlet="cellInner; context: { $implicit: item, slot: slot }"></ng-container>
      </a>
      <ng-template #interactiveCell>
        <div
          class="feature-grid-6__cell"
          [class]="'feature-grid-6__cell feature-grid-6__cell--' + slot.area"
          [class.feature-grid-6__cell--zoom]="zoomOnClick && item.mediaUrl"
          [attr.role]="zoomOnClick ? 'button' : 'listitem'"
          [attr.tabindex]="zoomOnClick && item.mediaUrl ? 0 : null"
          [attr.aria-label]="zoomOnClick ? (item.title || 'Open image') : null"
          (click)="onCellActivate(item)"
          (keydown)="onCellKeydown($event, item)"
        >
          <ng-container *ngTemplateOutlet="cellInner; context: { $implicit: item, slot: slot }"></ng-container>
        </div>
      </ng-template>
    </ng-container>
  </ng-container>
</div>

<ng-template #cellInner let-item let-slot="slot">
  <app-media-slot *ngIf="item.mediaType !== 'video'" fit="cover" [rounded]="false" class="feature-grid-6__media-slot">
    <img
      class="feature-grid-6__media"
      [appMediaSrc]="item.mediaUrl"
      [appMediaProfile]="mediaProfileForSlot(slot)"
      [appMediaSlotHint]="slot.hintPx"
      [appMediaSizes]="sizesForSlot(slot)"
      [appMediaSharp]="true"
      [appMediaProgressive]="false"
      appMediaPlaceholder="/assets/placeholder.svg"
      [alt]="item.title || ''"
      loading="lazy"
      decoding="async"
    />
  </app-media-slot>
  <video
    *ngIf="item.mediaType === 'video'"
    class="feature-grid-6__media"
    [appMediaSrc]="item.mediaUrl"
    muted
    loop
    playsinline
    autoplay
  ></video>
  <div class="feature-grid-6__overlay" *ngIf="item.badgeText || item.title || item.description">
    <span class="feature-grid-6__badge" *ngIf="item.badgeText">{{ item.badgeText }}</span>
    <h3 class="feature-grid-6__title" *ngIf="item.title">{{ item.title }}</h3>
    <p class="feature-grid-6__desc" *ngIf="item.description">{{ item.description }}</p>
  </div>
</ng-template>
